import { writable } from "svelte/store"
import { spotTypes, startYears } from "./Constants";

export const rank = writable(1);
export const grade = writable(125);
export const spotMargin = writable(0);
export const startYear = writable(startYears[startYears.length - 2])

export const selectedField = writable("");
export const selectedRegion = writable("");
export const selectedLocality = writable("");

export const expandAll = writable(false);

export const spotTypeBeforeAPICall = writable(spotTypes.IFE);
export const spotType = writable(spotTypes.IFE);

export const selectedField_dataViz = writable("");

export const userLoggedIn = writable(false);
export const userHasPremium = writable(true);
